import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const OneSupplierNote = ({ keptOneOfSeveral }: { keptOneOfSeveral: boolean }) => {
  const { t } = useTranslation();
  return (
    <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        {keptOneOfSeveral
          ? t(
              "A mini-competition is awarded to one supplier: the one with the best tender. Several tenders were marked in the evaluation, so only the best-ranked has been kept.",
            )
          : t("A mini-competition is awarded to one supplier: the one with the best tender.")}
      </AlertDescription>
    </Alert>
  );
};
